/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'automation-menu.empty-state.image.alt': 'Symbol: Leere Automatisierungsliste',
  'automation-menu.empty-state.learn-more.link': 'Weitere Informationen zum manuellen Trigger',
  'automation-menu.modal.empty.automations.admin.description':
    'Verwenden Sie den manuellen Trigger, um ein Auswahlmenü auszufüllen, das alle, oder von Ihnen festgelegte Personen, als Ein-Klick-Automatisierungen anwenden können.',
  'automation-menu.modal.empty.automations.user.description':
    'Die Administratoren haben noch keine Automatisierungen mit manuellem Trigger konfiguriert.',
  'automation-menu.modal.error.description':
    'Der Ladevorgang dauert eine Weile. Versuchen Sie, die Seite zu aktualisieren.',
  'automation-menu.modal.error.image.alt': 'Symbol: Fehler',
  'automation-menu.modal.footer.automate-button': 'Automatisieren',
  'automation-menu.modal.footer.cancel-button': 'Abbrechen',
  'automation-menu.modal.footer.get-started-button': 'Automatisierung erstellen',
  'automation-menu.modal.footer.ok-button': 'OK',
  'automation-menu.modal.header.icon.label': 'Symbol im Header des Automatisierungsfensters',
  'automation-menu.success-state.message': 'Ihre Automatisierungsregel wird ausgeführt',
  'fabric.linking.access_exists_description':
    'Bitten Sie Ihren Administrator um Zugriffsrechte für die Anzeige dieses Inhalts von {hostname}.',
  'fabric.linking.actions': 'Aktionen',
  'fabric.linking.add_account': 'Account hinzufügen',
  'fabric.linking.ai_summarize': 'Zusammenfassen',
  'fabric.linking.ai_summarized': 'Zusammengefasst von Atlassian Intelligence',
  'fabric.linking.ai_summarized_abbreviation': 'Von AI zusammengefasst',
  'fabric.linking.ai_summarized_info': 'Die Qualität der Informationen kann variieren. <a>Weitere Informationen</a>',
  'fabric.linking.ai_summarized_info_short': 'Die Qualität der Inhalte kann variieren.',
  'fabric.linking.ai_summarizing': 'Atlassian Intelligence arbeitet …',
  'fabric.linking.ai_summary_action': 'Atlassian Intelligence für Zusammenfassungen nutzen',
  'fabric.linking.ai_summary_action_description':
    'Lassen Sie sich den Inhalt dieses Links mithilfe von Atlassian Intelligence zusammenfassen.',
  'fabric.linking.ai_summary_error_acceptable_use_violation':
    'Die Ergebnisse dieser Zusammenfassung können nicht angezeigt werden, da sie gegen die <a>Richtlinie zur akzeptablen Nutzung von Atlassian verstößt</a>.',
  'fabric.linking.ai_summary_error_exceeding_context_length_error':
    'Atlassian Intelligence kann derzeit keine Zusammenfassung für Sie bereitstellen, da zu viele Inhalte zum Zusammenfassen vorhanden sind.',
  'fabric.linking.ai_summary_error_generic':
    'Atlassian Intelligence (AI) reagiert nicht. Versuchen Sie es später erneut oder <a>überprüfen Sie den Status von AI</a>.',
  'fabric.linking.ai_summary_error_hipaa_content_detected':
    'Atlassian Intelligence konnte Ihre Anfrage nicht bearbeiten, da sie Links zu HIPAA-beschränkten Inhalten enthält.',
  'fabric.linking.assigned_to': 'Zugewiesen an {context}',
  'fabric.linking.automation-action.confluence.page.modal.description':
    'Wenden Sie eine Automatisierung auf <b>{name}</b> an.{br}Die verfügbaren Auswahlen werden von Confluence- und Bereichsadministratoren gesteuert.',
  'fabric.linking.automation-action.confluence.page.modal.title': 'Seitenautomatisierungen',
  'fabric.linking.automation-action.icon.label': 'Symbol: Automatisierung',
  'fabric.linking.automation-action.title': 'Automatisierungsregeln anzeigen',
  'fabric.linking.automation-action.tooltip': 'Wählen Sie eine Automatisierungsregel aus, die ausgeführt werden soll.',
  'fabric.linking.beta': 'Beta',
  'fabric.linking.cancel': 'Abbrechen',
  'fabric.linking.cannot_connect': 'Verbindung nicht möglich, versuchen Sie es erneut',
  'fabric.linking.cannot_find_link': 'Link konnte nicht gefunden werden',
  'fabric.linking.check_this_link': 'Überprüfen Sie diesen Link',
  'fabric.linking.click_to_join': 'Werden Sie ein Teil von {context}',
  'fabric.linking.click_to_join_description': 'Ihre Anfrage wurde genehmigt und Sie können {context} direkt beitreten.',
  'fabric.linking.close': 'Schließen',
  'fabric.linking.connect_account_description':
    'Es wird eine neue Seite geöffnet, auf der Sie Ihr {name}-Konto verbinden können.',
  'fabric.linking.connect_link_account': 'Verknüpfen und Vorschau ansehen',
  'fabric.linking.connect_link_account_card_view': 'Verbinden',
  'fabric.linking.connect_link_account_card_view_description':
    'Verbinden Sie Ihr {context}-Konto, um eine Vorschau dieses Links anzuzeigen.',
  'fabric.linking.connect_link_account_card_view_name': 'Verbinden Sie Ihr {context}-Konto',
  'fabric.linking.connect_to': 'Mit {name} verbinden',
  'fabric.linking.connect_unauthorised_account_action': 'Mit {context} verbinden',
  'fabric.linking.connect_unauthorised_account_description':
    'Verbinden Sie Ihr {context}-Konto, um an verschiedenen Atlassian-Produkten mitzuarbeiten.',
  'fabric.linking.connect_unauthorised_account_description_no_provider':
    'Verbinden Sie Ihr Konto, um an verschiedenen Atlassian-Produkten mitzuarbeiten.',
  'fabric.linking.continue': 'Weiter',
  'fabric.linking.copied_summary_action_description': 'Zusammenfassung in die Zwischenablage kopiert',
  'fabric.linking.copied_url_to_clipboard': 'Kopiert!',
  'fabric.linking.copy_summary_action': 'Zusammenfassung kopieren',
  'fabric.linking.copy_summary_action_description': 'Zusammenfassung kopieren',
  'fabric.linking.copy_url_to_clipboard': 'Link kopieren',
  'fabric.linking.couldnt_load_link': 'Dieser Link konnte aus unbekannten Gründen nicht geladen werden.',
  'fabric.linking.create_on_absolute': 'Erstellt am: {context}',
  'fabric.linking.create_on_relative': 'Erstellt: {context}',
  'fabric.linking.created_by': 'Erstellt von {context}',
  'fabric.linking.delete': 'Löschen',
  'fabric.linking.direct_access': 'Jetzt beitreten',
  'fabric.linking.direct_access_description':
    'Ihr Team nutzt {product} bereits zur Zusammenarbeit und kann gleich loslegen!',
  'fabric.linking.direct_access_title': 'Treten Sie {product} bei, um diesen Inhalt anzuzeigen',
  'fabric.linking.download': 'Herunterladen',
  'fabric.linking.download_description': 'Diese Datei wird in Ihren lokalen Speicher heruntergeladen.',
  'fabric.linking.download_file': 'Datei herunterladen',
  'fabric.linking.edit': 'Bearbeiten',
  'fabric.linking.follow': 'Folgen',
  'fabric.linking.follow_goal': 'Ziel folgen',
  'fabric.linking.follow_goal_description': 'Folgen Sie diesem Ziel, um Benachrichtigungen zu Updates zu erhalten.',
  'fabric.linking.follow_goal_error':
    'Beim Versuch, dem Ziel zu folgen, ist ein Fehler aufgetreten. Überprüfen Sie Ihre Verbindung oder aktualisieren Sie die Seite und versuchen Sie es erneut.',
  'fabric.linking.follow_project': 'Projekt folgen',
  'fabric.linking.follow_project-galaxia': 'Raum folgen',
  'fabric.linking.follow_project_description':
    'Folgen Sie diesem Projekt, um Benachrichtigungen zu Updates zu erhalten.',
  'fabric.linking.follow_project_description-galaxia':
    'Folgen Sie diesem Space, um Benachrichtigungen zu Updates zu erhalten.',
  'fabric.linking.follow_project_error':
    'Beim Versuch, dem Projekt zu folgen, ist ein Fehler aufgetreten. Überprüfen Sie Ihre Verbindung oder aktualisieren Sie die Seite und versuchen Sie es erneut.',
  'fabric.linking.follow_project_error-galaxia':
    'Beim Versuch, dem Space zu folgen, ist ein Fehler aufgetreten. Überprüfen Sie Ihre Verbindung oder aktualisieren Sie die Seite und versuchen Sie es erneut.',
  'fabric.linking.forbidden_access': 'Sie sind nicht zugriffsberechtigt',
  'fabric.linking.forbidden_description': 'Bitten Sie Ihren Administrator um Zugriffsrechte für {hostname}.',
  'fabric.linking.forbidden_title': 'Sie haben keinen Zugriff auf diesen Inhalt',
  'fabric.linking.generic_error_message': 'Ein Fehler ist aufgetreten',
  'fabric.linking.go_back': 'Zurück',
  'fabric.linking.invalid_permissions': 'Inhalt mit Beschränkungen',
  'fabric.linking.invalid_permissions_description':
    'Bitte senden Sie eine Zugriffsanfrage oder versuchen Sie, die Vorschau über ein anderes Konto anzusehen.',
  'fabric.linking.join_to_view': '{context} beitreten, um diesen Vorgang anzuzeigen',
  'fabric.linking.join_to_view-issue-term-refresh': '{context} beitreten, um diesen Vorgang anzuzeigen',
  'fabric.linking.learn_more_about_connecting_account':
    'Weitere Informationen zum Verbinden Ihres Kontos mit Atlassian-Produkten',
  'fabric.linking.learn_more_about_smart_links': 'Mehr über intelligente Links erfahren',
  'fabric.linking.link_safety_warning_message':
    'Über den Link {unsafeLinkText} gelangen Sie zu einer anderen Site, <a>actual link here</a>',
  'fabric.linking.loading': 'Lädt ...',
  'fabric.linking.modified_on_absolute': 'Aktualisiert am: {context}',
  'fabric.linking.modified_on_relative': 'Aktualisiert: {context}',
  'fabric.linking.more_actions': 'Weitere Aktionen',
  'fabric.linking.no_access_title': 'Treten Sie {product} bei, um diesen Inhalt anzuzeigen',
  'fabric.linking.not_found_description':
    'Die Seite existiert nicht oder sie hat sich möglicherweise geändert, nachdem dieser Link hinzugefügt wurde.',
  'fabric.linking.not_found_title': 'Diese {product}-Seite kann nicht angezeigt werden',
  'fabric.linking.open_issue_in_jira': 'Vorgang in Jira öffnen',
  'fabric.linking.open_issue_in_jira-issue-term-refresh': 'Vorgang in Jira öffnen',
  'fabric.linking.open_link_in_a_new_tab': 'Link in neuer Registerkarte öffnen',
  'fabric.linking.owned_by': 'Besitzer: {context}',
  'fabric.linking.owned_by_override': 'Von {context}',
  'fabric.linking.pending_request': 'Ihre Zugriffsanfrage ist ausstehend.',
  'fabric.linking.preview_close': 'Vorschau beenden',
  'fabric.linking.preview_description': 'Es wird eine Vorschau dieses Links im Vollbildmodus geöffnet.',
  'fabric.linking.preview_improved': 'Vorschau öffnen',
  'fabric.linking.preview_max_size': 'Vollbildansicht anzeigen',
  'fabric.linking.preview_min_size': 'Vollbildansicht beenden',
  'fabric.linking.preview_modal': 'Vorschaufenster öffnen',
  'fabric.linking.preview_panel': 'Vorschaupanel öffnen',
  'fabric.linking.priority_blocker': 'Blocker',
  'fabric.linking.priority_critical': 'Kritisch',
  'fabric.linking.priority_high': 'Hoch',
  'fabric.linking.priority_highest': 'Höchste',
  'fabric.linking.priority_low': 'Niedrig',
  'fabric.linking.priority_lowest': 'Niedrigste',
  'fabric.linking.priority_major': 'Schwerwiegend',
  'fabric.linking.priority_medium': 'Mittel',
  'fabric.linking.priority_minor': 'Geringfügig',
  'fabric.linking.priority_trivial': 'Unwesentlich',
  'fabric.linking.priority_undefined': 'Nicht definiert',
  'fabric.linking.read_time': 'Lesedauer: {context} Min.',
  'fabric.linking.related': 'Zugehörig',
  'fabric.linking.related_links_found_in': 'Gefunden in',
  'fabric.linking.related_links_includes_links_to': 'Beinhaltet Links zu',
  'fabric.linking.related_links_modal_error_description':
    'Überprüfen Sie Ihre Verbindung oder aktualisieren Sie die Seite, um es erneut zu versuchen.',
  'fabric.linking.related_links_modal_error_title': 'Beim Laden der zugehörigen Links ist ein Problem aufgetreten',
  'fabric.linking.related_links_modal_title': 'Zugehörige Links',
  'fabric.linking.related_links_modal_unavailable_description':
    'Wir überprüfen fortlaufend zugehörige Links für aktualisierte Seiten oder andere Inhaltstypen und fügen sie hinzu.',
  'fabric.linking.related_links_modal_unavailable_title': 'Es konnten keine zugehörigen Links gefunden werden',
  'fabric.linking.related_links_not_found': 'Es wurden keine Links zum Anzeigen gefunden.',
  'fabric.linking.related_links_view_related_links': 'Zugehörige Links anzeigen',
  'fabric.linking.related_links_view_related_urls': 'Letzte Links anzeigen',
  'fabric.linking.request_access': 'Zugriff anfordern',
  'fabric.linking.request_access_description':
    'Ihr Team verwendet {product} zur Zusammenarbeit. Senden Sie Ihrem Administrator eine Zugriffsanfrage.',
  'fabric.linking.request_access_pending': 'Genehmigung ausstehend',
  'fabric.linking.request_access_pending_description':
    'Ihre Zugriffsanfrage für {hostname} wartet auf die Genehmigung durch den Administrator.',
  'fabric.linking.request_access_pending_title': 'Zugriff auf {product} ausstehend',
  'fabric.linking.request_access_to_view': 'Zugriff auf {context} anfordern, um diesen Vorgang anzuzeigen',
  'fabric.linking.request_access_to_view-issue-term-refresh':
    'Zugriff auf {context} anfordern, um diesen Vorgang anzuzeigen',
  'fabric.linking.request_denied': 'Ihre Zugriffsanfrage wurde abgelehnt.',
  'fabric.linking.request_denied_description':
    'Ihr Administrator hat Ihre Anfrage zur Anzeige der {product}-Seiten von {hostname} nicht genehmigt.',
  'fabric.linking.restricted_link': 'Eingeschränkter Link, bitte versuchen Sie es mit einem anderen Konto.',
  'fabric.linking.retry': 'Erneut versuchen',
  'fabric.linking.save': 'Speichern',
  'fabric.linking.sent_on_absolute': 'Gesendet am {context}',
  'fabric.linking.sent_on_relative': 'Gesendet: {context}',
  'fabric.linking.srclink': 'Anzeigen in',
  'fabric.linking.srclinkunknown': 'Original anzeigen',
  'fabric.linking.status_change_load_error': 'Status und Übergänge konnten nicht geladen werden',
  'fabric.linking.status_change_permission_error': 'Sie sind nicht berechtigt, diesen Vorgang weiterzugeben.',
  'fabric.linking.status_change_permission_error-issue-term-refresh':
    'Sie sind nicht berechtigt, diesen Vorgang weiterzugeben.',
  'fabric.linking.status_change_update_error': 'Der Status konnte nicht aktualisiert werden',
  'fabric.linking.team_members_count': '{context} Mitglieder',
  'fabric.linking.try_again': 'Versuchen Sie es erneut.',
  'fabric.linking.try_another_account': 'Versuchen Sie es mit einem anderen Konto erneut.',
  'fabric.linking.unassigned': 'Nicht zugewiesen',
  'fabric.linking.unauthorised_account_description':
    'Sie versuchen, die Vorschau eines Links zu einer privaten {context}-Seite anzuzeigen. Überprüfen Sie die URL oder wenden Sie sich an den Seitenbesitzer.',
  'fabric.linking.unauthorised_account_description_no_provider':
    'Sie versuchen, die Vorschau eines Links zu einer privaten Seite anzuzeigen. Überprüfen Sie die URL oder wenden Sie sich an den Seitenbesitzer.',
  'fabric.linking.unauthorised_account_name': 'Private Seiten von {context} können nicht angezeigt werden',
  'fabric.linking.unauthorised_account_name_no_provider': 'Private Seiten können nicht angezeigt werden',
  'fabric.linking.unfollow': 'Nicht mehr folgen',
  'fabric.linking.unfollow_goal': 'Ziel nicht mehr folgen',
  'fabric.linking.unfollow_goal_description':
    'Nicht mehr folgen, um keine Benachrichtigungen für dieses Ziel mehr zu erhalten',
  'fabric.linking.unfollow_goal_error':
    'Beim Versuch, dem Ziel nicht mehr zu folgen, ist ein Fehler aufgetreten. Überprüfen Sie Ihre Verbindung oder aktualisieren Sie die Seite und versuchen Sie es erneut.',
  'fabric.linking.unfollow_project': 'Projekt nicht mehr folgen',
  'fabric.linking.unfollow_project-galaxia': 'Space nicht mehr folgen',
  'fabric.linking.unfollow_project_description':
    'Nicht mehr folgen, um keine Benachrichtigungen für dieses Projekt mehr zu erhalten',
  'fabric.linking.unfollow_project_description-galaxia':
    'Nicht mehr folgen, um keine Benachrichtigungen für diesen Space mehr zu erhalten',
  'fabric.linking.unfollow_project_error':
    'Beim Versuch, dem Projekt nicht mehr zu folgen, ist ein Fehler aufgetreten. Überprüfen Sie Ihre Verbindung oder aktualisieren Sie die Seite und versuchen Sie es erneut.',
  'fabric.linking.unfollow_project_error-galaxia':
    'Beim Versuch, dem Space nicht mehr zu folgen, ist ein Fehler aufgetreten. Überprüfen Sie Ihre Verbindung oder aktualisieren Sie die Seite und versuchen Sie es erneut.',
  'fabric.linking.unlink_account': 'Kontoverknüpfung löschen',
  'fabric.linking.updated_by': 'Geändert von {context}',
  'fabric.linking.user_attributes': '{context}',
  'fabric.linking.view': 'Anzeigen',
};
